 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"admin-app-links":"admin-app-links","admin-banking":"admin-banking","admin-custom-attributes":"admin-custom-attributes","admin-design-feed":"admin-design-feed","admin-exemption-certificates":"admin-exemption-certificates","admin-master-accounts":"admin-master-accounts","admin-orders":"admin-orders","admin-product-setup-category":"admin-product-setup-category","admin-product-setup-entry":"admin-product-setup-entry","admin-product-setup-industries":"admin-product-setup-industries","admin-reports-payments":"admin-reports-payments","admin-reports-payouts":"admin-reports-payouts","admin-setup-coreproduct":"admin-setup-coreproduct","admin-setup-material":"admin-setup-material","admin-subscription":"admin-subscription","admin-users":"admin-users","asset-projects":"asset-projects","campaigns":"campaigns","cards":"cards","contributor-payouts":"contributor-payouts","contributor-projects":"contributor-projects","dashboard":"dashboard","image-projects":"image-projects","notfound":"notfound","order-detail":"order-detail","order-history":"order-history","print":"print","print-checkout-iframe":"print-checkout-iframe","profile":"profile","project-details":"project-details","projects":"projects","shared-projects":"shared-projects","subscription":"subscription","subscription-checkout-iframe":"subscription-checkout-iframe","vendors~admin-api-docs":"vendors~admin-api-docs","admin-api-docs":"admin-api-docs","vendors~admin-collections~admin-settings":"vendors~admin-collections~admin-settings","admin-collections":"admin-collections","admin-settings":"admin-settings"}[chunkId]||chunkId) + "." + {"admin-app-links":"2b13c100","admin-banking":"a46960c4","admin-custom-attributes":"1231aa2c","admin-design-feed":"a1585ca6","admin-exemption-certificates":"1fd7f858","admin-master-accounts":"52252d42","admin-orders":"804464dc","admin-product-setup-category":"d5dbe8f2","admin-product-setup-entry":"5b34afa0","admin-product-setup-industries":"58f1f356","admin-reports-payments":"901dd449","admin-reports-payouts":"05958a71","admin-setup-coreproduct":"fd267262","admin-setup-material":"8241168d","admin-subscription":"a6b5110f","admin-users":"ded2647f","asset-projects":"d76164aa","campaigns":"dc2443b7","cards":"12560f0e","contributor-payouts":"4a4ea990","contributor-projects":"7bfcf5c9","dashboard":"956f68f3","image-projects":"1bb92178","notfound":"c8b42082","order-detail":"2a327646","order-history":"539a3096","print":"8b7684fe","print-checkout-iframe":"9261f56a","profile":"76452db1","project-details":"f572965c","projects":"e10cb059","shared-projects":"89ed4868","subscription":"3bfad008","subscription-checkout-iframe":"967c59b3","vendors~admin-api-docs":"6ff3400c","admin-api-docs":"1919b655","vendors~admin-collections~admin-settings":"3938d8d4","admin-collections":"900a3740","admin-settings":"74ecfc78"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"admin-master-accounts":1,"admin-orders":1,"admin-product-setup-entry":1,"asset-projects":1,"contributor-projects":1,"dashboard":1,"image-projects":1,"order-history":1,"projects":1,"subscription":1,"vendors~admin-api-docs":1,"admin-api-docs":1,"vendors~admin-collections~admin-settings":1,"admin-collections":1,"admin-settings":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"admin-app-links":"admin-app-links","admin-banking":"admin-banking","admin-custom-attributes":"admin-custom-attributes","admin-design-feed":"admin-design-feed","admin-exemption-certificates":"admin-exemption-certificates","admin-master-accounts":"admin-master-accounts","admin-orders":"admin-orders","admin-product-setup-category":"admin-product-setup-category","admin-product-setup-entry":"admin-product-setup-entry","admin-product-setup-industries":"admin-product-setup-industries","admin-reports-payments":"admin-reports-payments","admin-reports-payouts":"admin-reports-payouts","admin-setup-coreproduct":"admin-setup-coreproduct","admin-setup-material":"admin-setup-material","admin-subscription":"admin-subscription","admin-users":"admin-users","asset-projects":"asset-projects","campaigns":"campaigns","cards":"cards","contributor-payouts":"contributor-payouts","contributor-projects":"contributor-projects","dashboard":"dashboard","image-projects":"image-projects","notfound":"notfound","order-detail":"order-detail","order-history":"order-history","print":"print","print-checkout-iframe":"print-checkout-iframe","profile":"profile","project-details":"project-details","projects":"projects","shared-projects":"shared-projects","subscription":"subscription","subscription-checkout-iframe":"subscription-checkout-iframe","vendors~admin-api-docs":"vendors~admin-api-docs","admin-api-docs":"admin-api-docs","vendors~admin-collections~admin-settings":"vendors~admin-collections~admin-settings","admin-collections":"admin-collections","admin-settings":"admin-settings"}[chunkId]||chunkId) + "." + {"admin-app-links":"31d6cfe0","admin-banking":"31d6cfe0","admin-custom-attributes":"31d6cfe0","admin-design-feed":"31d6cfe0","admin-exemption-certificates":"31d6cfe0","admin-master-accounts":"23ec521d","admin-orders":"05336959","admin-product-setup-category":"31d6cfe0","admin-product-setup-entry":"402f1dfe","admin-product-setup-industries":"31d6cfe0","admin-reports-payments":"31d6cfe0","admin-reports-payouts":"31d6cfe0","admin-setup-coreproduct":"31d6cfe0","admin-setup-material":"31d6cfe0","admin-subscription":"31d6cfe0","admin-users":"31d6cfe0","asset-projects":"76a811a3","campaigns":"31d6cfe0","cards":"31d6cfe0","contributor-payouts":"31d6cfe0","contributor-projects":"32af4b7e","dashboard":"f3564362","image-projects":"76a811a3","notfound":"31d6cfe0","order-detail":"31d6cfe0","order-history":"7f325b03","print":"31d6cfe0","print-checkout-iframe":"31d6cfe0","profile":"31d6cfe0","project-details":"31d6cfe0","projects":"f3564362","shared-projects":"31d6cfe0","subscription":"91a50f00","subscription-checkout-iframe":"31d6cfe0","vendors~admin-api-docs":"1740b541","admin-api-docs":"19c8f44c","vendors~admin-collections~admin-settings":"dd0af666","admin-collections":"46800d25","admin-settings":"f27179d5"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/app/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 0);
